<template>
  <!--相关协议-->
  <div class="order-protocol">
    <p class="select _id_danxuanxiang"
       :class="[newCheckAgree ? 'selectYes' : 'selectNo']"
       @click="handleClickCheckAgree"></p>
    <span class="read">我已阅读并同意</span>
    <div
      @click="handleGotoProtocol"
      class="ptl">《借款相关协议》</div>
    <div
      v-if="['100000282'].includes(category)"
      @click="handleGoUserProtocol"
      class="ptl">《个人信息承诺书》</div>
  </div>
</template>

<script>
export default {
  name: 'protocol',
  props: {
    liveProvince: {
      type: String,
      default: null
    },
    checkAgree: {
      type: Boolean,
      default: true
    },
    protocolName: {
      type: Array,
      default () {
        return []
      }
    },
    protocolUrl: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      category: localStorage.getItem('category') || null, // 产品类型
      newCheckAgree: this.checkAgree
    }
  },
  watch: {
    checkAgree (val) {
      if (val) {
        this.newCheckAgree = val
      }
    }
  },
  methods: {
    // 点击勾选按钮
    handleClickCheckAgree () {
      if (!this.newCheckAgree) {
        this.$emit('update:showProtocolDialog', true)
      } else {
        this.newCheckAgree = !this.newCheckAgree
        this.$emit('update:checkAgree1', this.newCheckAgree)
      }
    },
    handleGoUserProtocol () {
      this.$router.push({
        name: 'protocol_hjt_personInfoPromise',
        query: { liveProvince: this.liveProvince }
      })
    },
    // 相关协议
    handleGotoProtocol () {
      this.$router.push({
        name: 'borrow_protocolList'
      })
    }
  }
}
</script>

<style lang="less">
.order-protocol {
  min-height: 0.66rem;
  margin-top: 0.15rem;
  padding: 0 0.24rem 0 0.4rem;
  line-height: 0.66rem;
  .select {
    width: 0.32rem;
    height: 0.32rem;
    display: inline-block;
    line-height: 0.4rem;
    margin-right: 0.06rem;
    vertical-align: middle;
  }
  .selectYes {
    background-image: url("~@/assets/img/borrow/icon-selected.png");
    background-size: cover;
  }
  .selectNo {
    background-image: url("~@/assets/img/borrow/icon-selected-no.png");
    background-size: cover;
  }
  .read, .ptl {
    font-size: 0.26rem;
    line-height: 0.32rem;
    display: inline;
    vertical-align: middle;
  }
  .read {
    color: #ababab;
  }
  .ptl {
    color: #4a90e2;
  }
}
</style>
